const aiSevne = [
  {
      "name": "FlowGPT",
      "url": "https://flowgpt.com/",
      "icon": "images/flowgpt.png",
      "description": "一个分享和讨论ChatGPT聊天指令（提示词）的平台，用户可以在这里交流如何更好地与ChatGPT互动，获取高效提示词技巧。",
      isVpn: true
  },
  // {
  //     "name": "PromptHero",
  //     "url": "https://prompthero.com",
  //     "icon": "images/prompthero.jpg",
  //     "description": "专注于稳定扩散（Stable Diffusion）的搜索提示词工具，提供高质量图像生成提示词库，帮助用户优化AI绘画效果。"
  // },
  {
      "name": "ClickPrompt",
      "url": "https://clickprompt.org",
      "icon": "images/clickprompt.png",
      "description": "简化提示词设计的工具，通过可视化界面降低提示词构建门槛，提升用户与AI交互的效率。"
  },
  {
      "name": "Public Prompts",
      "url": "https://publicprompts.art/",
      "icon": "images/public-prompts.png",
      "description": "提供公共可用的提示词资源平台，用户可免费获取各类场景下的优质提示词，适用于快速入门AI交互。"
  },
  {
      "name": "AIPRM",
      "url": "https://www.aiprm.com/",
      "icon": "images/aiprm.png",
      "description": "专为ChatGPT设计的提示词工具，支持一键生成专业提示词模板，覆盖营销、编程、创作等多场景，提升AI输出质量。"
  },
  {
      "name": "PromptBase",
      "url": "https://promptbase.com/",
      "icon": "images/prompybase.png",
      "description": "AI提示词集合市场，汇聚海量优质提示词，支持分类搜索和用户分享，满足不同领域的AI交互需求。"
  },
  {
      "name": "SnackPrompt",
      "url": "https://snackprompt.com/",
      "icon": "images/snackPrimop.png",
      "description": "为ChatGPT优化提示词的平台，提供简洁易用的提示词编辑工具，帮助用户快速生成高效指令。"
  },
  {
      "name": "Prompts.Chat",
      "url": "https://prompts.chat/",
      "icon": "images/prompts-gpt.jpg",
      "description": "专注于ChatGPT提示词的分享与交流社区，用户可浏览、收藏和自定义提示词，提升与AI的对话效果。"
  },
  {
      "name": "LearningPrompt",
      "url": "https://learningprompt.wiki/",
      "icon": "images/learningprompt.png",
      "description": "提供ChatGPT提示词学习资源的平台，包含教程、案例和最佳实践，帮助用户掌握提示工程技巧。"
  },
  {
      "name": "AiShort",
      "url": "https://www.aishort.top/",
      "icon": "images/ai-short.png",
      "description": "聚焦AI快捷指令的工具，通过预设模板和参数调整，让用户快速生成高效提示词，提升生产力。"
  },
  {
      "name": "Prompt Engineering Guide",
      "url": "https://www.promptingguide.ai/zh",
      "icon": "images/Prompt-Engineering-guide.jpg",
      "description": "专注于提示工程的权威指南平台，提供理论知识、实战技巧和工具推荐，帮助用户设计高质量提示词。"
  },
  {
      "name": "AI绘嗨",
      "url": "https://www.zs9.com/newest?cate=2",
      "icon": "images/AI-huihai.png",
      "description": "AI绘画提示词分享社区，用户可上传、浏览和下载适用于Stable Diffusion等模型的提示词，提升绘画生成效果。"
  },
  {
      "name": "词魂",
      "url": "https://cihun.ai",
      "icon": "images/cihun.png",
      "description": "AIGC领域的精品提示词库，涵盖图像生成、文本创作等场景，提供专业级提示词资源和优化建议。"
  },
  {
      "name": "Kimi提示词工具",
      "url": "https://kimi.com/prompt",
      "icon": "images/kimi-logo.png",
      "description": "零门槛提示词优化工具，通过智能分析和推荐，帮助用户快速生成高效提示词，提升与AI的交互效果。"
  }
]

export default aiSevne
